import { ButtonERP } from "@finanedi.es/storybook"
import { useGetDetalleAmortizacionActivoById } from "api/Activo.hook"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import AmortizacionImg from "../../assets/activoDetailEmpty.svg"
import { DetalleAmortizacion } from "./DetalleAmortizacion"
import { TablaActivoId } from "./TablaActivoId"

export const TabAmortizacion = ({
  openAmortizar,
  esAmortizable,
}: {
  openAmortizar: () => void
  esAmortizable?: boolean
}) => {
  const { t } = useTranslation()
  const { activoId } = useParams<{ activoId: string }>()
  const { detalleAmortizacionActivo } =
    useGetDetalleAmortizacionActivoById(activoId)

  return esAmortizable && detalleAmortizacionActivo?.concepto ? (
    <div className='tw-justify-between tw-mt-8 tw-gap-x-6 tw-w-full tw-space-y-6 tw-h-full'>
      <article className='tw-w-full tw-text-left tw-gap-x-4'>
        <DetalleAmortizacion />
      </article>
      <TablaActivoId amortizar={openAmortizar} />
    </div>
  ) : (
    <>
      <div
        key='Amortizacion'
        className='tw-w-full tw-bg-white tw-mt-8 tw-rounded-lg tw-shadow-sm'
      >
        <section className='tw-grid tw-place-content-center tw-gap-y-10 tw-py-20'>
          <img
            className='tw-mx-auto tw-w-full'
            src={AmortizacionImg}
            alt={`${t("nsAssets.tabAmortizable.nonAmortizableTitle")}`}
          />
          <div className='tw-grid tw-grid-cols-1 tw-place-content-center tw-justify-center'>
            <h3 className='tw-text-center tw-text-3xl tw-font-bold tw-text-primary tw-mb-3'>
              {t("nsAssets.tabAmortizable.nonAmortizableTitle")}
            </h3>
            <p className='tw-text-center tw-text-base tw-font-normal tw-text-text tw-mb-6'>
              {t("nsAssets.tabAmortizable.nonAmortizableSubtitle")}
            </p>
            <div className='tw-flex tw-justify-center tw-w-full'>
              <ButtonERP
                label={`${t("nsAssets.tabAmortizable.assetAmortize")}`}
                customize={{
                  type: "secondary",
                  size: "md",
                }}
                className='tw-w-fit'
                onClick={openAmortizar}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
